const ICON_PATHS: Record<string, string[]> = {
	security: ['M12 3 5 6v5c0 5 3.4 8.6 7 10 3.6-1.4 7-5 7-10V6l-7-3Z', 'm9.5 12 1.7 1.7 3.5-3.7'],
	billing: ['M4 6h16v12H4z', 'M4 10h16', 'M8 15h3'],
	community: ['M5 5h14v10H9l-4 4V5Z', 'M9 9h6'],
	referral: ['M7 5a3 3 0 1 0 0 6 3 3 0 1 0 0-6', 'M17 5a3 3 0 1 0 0 6 3 3 0 1 0 0-6', 'M1.5 21a5.5 5.5 0 0 1 11 0', 'M11.5 21a5.5 5.5 0 0 1 11 0', 'M10 8h4'],
	quota: ['m12 14 4-4', 'M3.34 19a10 10 0 1 1 17.32 0'],
	ai_create: ['M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z', 'M20 2v4', 'M22 4h-4', 'M4 18a2 2 0 1 0 0 4 2 2 0 1 0 0-4'],
	feedback: ['M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z', 'm10 8-3 3 3 3', 'M17 14v-1a2 2 0 0 0-2-2H7'],
};

/** Shared, inline-SVG notification icon. Text never enters this visual boundary. */
export function createNotificationIcon(doc: Document, category: string, className: string): SVGSVGElement {
	const svg = doc.createElementNS('http://www.w3.org/2000/svg', 'svg');
	svg.setAttribute('class', className);
	svg.setAttribute('viewBox', '0 0 24 24');
	svg.setAttribute('fill', 'none');
	svg.setAttribute('stroke', 'currentColor');
	svg.setAttribute('stroke-width', '1.8');
	svg.setAttribute('stroke-linecap', 'round');
	svg.setAttribute('stroke-linejoin', 'round');
	svg.setAttribute('aria-hidden', 'true');
	for (const d of ICON_PATHS[category] ?? ['M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z', 'M12 8v5', 'M12 16h.01']) {
		const path = doc.createElementNS('http://www.w3.org/2000/svg', 'path');
		path.setAttribute('d', d);
		svg.appendChild(path);
	}
	return svg;
}
